import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type="number"]',
  standalone: false,
})
export class InputNumberDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('click')
  onClick() {
    /**
     * Handle clicking on the spinner wheels, this will
     * be a click event without the element having focus.
     * Trigger blur so form controls display as "touched".
     */
    if (document.activeElement !== this.el.nativeElement) {
      this.el.nativeElement.dispatchEvent(new CustomEvent('blur'));
    }
  }
}
